import { useState, useEffect } from "react";

// Components
import {
  Header,
  Body,
  Footer,
  Button,
  TimePicker,
  InlineCalendar
} from "../../../components/UI";
import { Heading2, Label } from "../../../components/typography";

// Icons
import { Close } from "../../../SVGS";

// Builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";

// Utils
import { getUtcDateObject } from "../../../utils/timeStampToDate";

// Styles
import { EtaFormStyles } from "./eta-form.styles";

const EtaForm = ({ initialDateValue, closeModal, updateEstimationDate }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (initialDateValue) {
      setValue(getUtcDateObject(initialDateValue));
    }
  }, [initialDateValue]);
  return (
    <EtaFormStyles>
      <Header className="header">
        <Heading2 className="headerTitle">
          Change estimation date and time
        </Heading2>
        <Close onClick={closeModal} />
      </Header>
      <Body className="formBody">
        <InlineCalendar value={value} onChange={date => setValue(date)} />
        <div className="inputContainer">
          <Label>Time</Label>
          <TimePicker
            value={value}
            dateFormat="hh : mm aa"
            handleChange={date => setValue(date)}
          />
        </div>
      </Body>
      <Footer className="footer">
        <Button
          className="saveButton"
          onClick={() => updateEstimationDate(value)}
          buttonDesignType={buttonDesignType.PRIMARY}
        >
          Save Changes
        </Button>
      </Footer>
    </EtaFormStyles>
  );
};

export default EtaForm;
